function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.364 0C23.864 0 30 6.136 30 13.636v21.137c0 1.909-1.5 3.409-3.41 3.409H3.41c-1.91 0-3.41-1.5-3.41-3.41V3.41C0 1.5 1.5 0 3.41 0zM15 2.727H3.41c-.41 0-.683.273-.683.682v31.364c0 .409.273.682.682.682h23.182c.409 0 .682-.273.682-.682V15c0-1.5-1.228-2.727-2.728-2.727h-5.454c-.75 0-1.364-.614-1.364-1.364V5.455c0-1.5-1.227-2.728-2.727-2.728zm0 12.955c4.5 0 8.182 3.682 8.182 8.182S19.5 32.045 15 32.045s-8.182-3.681-8.182-8.181c0-4.5 3.682-8.182 8.182-8.182zm4.636 5.454l-7.431 7.432c.818.477 1.772.75 2.795.75 3 0 5.455-2.454 5.386-5.386a5.527 5.527 0 00-.75-2.796zM15 18.41c-3 0-5.455 2.455-5.455 5.455 0 1.022.273 1.977.75 2.795l7.5-7.5A5.527 5.527 0 0015 18.41zm5.045-15c.273.614.41 1.296.41 2.046v4.09h4.09c.682 0 1.432.137 2.046.41a10.739 10.739 0 00-6.546-6.546z",
  fill: "currentColor",
  fillRule: "nonzero"
});

function SvgProhibitedDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 39,
    viewBox: "0 0 30 39",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProhibitedDocument);
export default __webpack_public_path__ + "static/media/prohibited-document.b2b05888.svg";
export { ForwardRef as ReactComponent };